/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { Department } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService extends ApiClient {
  constructor(private httpClient: HttpClient) {
    super();
  }

  getDepartments(): Observable<Department[]> {
    return this.httpClient.get<Department[]>(`${environment.backendServer}/api/departments`, {
      headers: this.LD_JSON_HEADERS
    }).pipe(
      map(response => response['hydra:member'])
    );
  }

  getDepartment(id: string): Observable<Department> {
    return this.httpClient.get<Department>(`${environment.backendServer}/api/departments/${this.extractId(id)}`, {
      headers: this.LD_JSON_HEADERS
    });
  }

  createDepartment(department: Department): Observable<Department> {
    return this.httpClient.post<Department>(`${environment.backendServer}/api/departments`, department, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  updateDepartment(department: Department): Observable<Department> {
    return this.httpClient.put<Department>(
      `${environment.backendServer}/api/departments/${this.extractId(department['@id'])}`,
      department,
      {
        headers: this.LD_JSON_HEADERS,
        observe: 'response'
      }
    ).pipe(
      map(response => response.body)
    );
  }

  deleteDepartment(id: string): Observable<any> {
    return this.httpClient.delete(`${environment.backendServer}/api/departments/${this.extractId(id)}`, {
      observe: 'response'
    });
  }
}
